import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Product Identifier icon. Exported from Figma (Bombiix 2026). */
const ProductIdentifierIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M23.251 10.5C23.251 8.89295 22.7952 7.86869 22.1152 7.2373C21.4252 6.59664 20.3859 6.25 19.001 6.25H9.00098C7.61602 6.25 6.57674 6.59664 5.88672 7.2373C5.20677 7.86869 4.75098 8.89295 4.75098 10.5V17.5C4.75098 19.107 5.20677 20.1313 5.88672 20.7627C6.57674 21.4034 7.61602 21.75 9.00098 21.75H19.001C20.3859 21.75 21.4252 21.4034 22.1152 20.7627C22.7952 20.1313 23.251 19.107 23.251 17.5V10.5ZM24.751 17.5C24.751 19.3929 24.2067 20.8687 23.1367 21.8623C22.0767 22.8466 20.6159 23.25 19.001 23.25H9.00098C7.38601 23.25 5.92522 22.8466 4.86523 21.8623C3.79526 20.8687 3.25098 19.3929 3.25098 17.5V10.5C3.25098 8.60712 3.79526 7.13131 4.86523 6.1377C5.92522 5.15342 7.38601 4.75 9.00098 4.75H19.001C20.6159 4.75 22.0767 5.15342 23.1367 6.1377C24.2067 7.13131 24.751 8.60712 24.751 10.5V17.5Z"
      fill="currentColor"
    />
    <path
      d="M7.25 18V10C7.25 9.58579 7.58579 9.25 8 9.25C8.41421 9.25 8.75 9.58579 8.75 10V18C8.75 18.4142 8.41421 18.75 8 18.75C7.58579 18.75 7.25 18.4142 7.25 18Z"
      fill="currentColor"
    />
    <path
      d="M10.25 14V10C10.25 9.58579 10.5858 9.25 11 9.25C11.4142 9.25 11.75 9.58579 11.75 10V14C11.75 14.4142 11.4142 14.75 11 14.75C10.5858 14.75 10.25 14.4142 10.25 14Z"
      fill="currentColor"
    />
    <path
      d="M10.25 18V17C10.25 16.5858 10.5858 16.25 11 16.25C11.4142 16.25 11.75 16.5858 11.75 17V18C11.75 18.4142 11.4142 18.75 11 18.75C10.5858 18.75 10.25 18.4142 10.25 18Z"
      fill="currentColor"
    />
    <path
      d="M16.25 11V10C16.25 9.58579 16.5858 9.25 17 9.25C17.4142 9.25 17.75 9.58579 17.75 10V11C17.75 11.4142 17.4142 11.75 17 11.75C16.5858 11.75 16.25 11.4142 16.25 11Z"
      fill="currentColor"
    />
    <path
      d="M13.25 18V10C13.25 9.58579 13.5858 9.25 14 9.25C14.4142 9.25 14.75 9.58579 14.75 10V18C14.75 18.4142 14.4142 18.75 14 18.75C13.5858 18.75 13.25 18.4142 13.25 18Z"
      fill="currentColor"
    />
    <path
      d="M16.25 18V14C16.25 13.5858 16.5858 13.25 17 13.25C17.4142 13.25 17.75 13.5858 17.75 14V18C17.75 18.4142 17.4142 18.75 17 18.75C16.5858 18.75 16.25 18.4142 16.25 18Z"
      fill="currentColor"
    />
    <path
      d="M19.25 18V10C19.25 9.58579 19.5858 9.25 20 9.25C20.4142 9.25 20.75 9.58579 20.75 10V18C20.75 18.4142 20.4142 18.75 20 18.75C19.5858 18.75 19.25 18.4142 19.25 18Z"
      fill="currentColor"
    />
  </svg>
);

export default ProductIdentifierIcon;
